import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50 pt-16">
      <div className="text-center px-4">
        <h1 className="text-6xl md:text-8xl font-bold text-foreground-200" style={{ fontFamily: 'var(--font-heading)' }}>
          404
        </h1>
        <h2 className="mt-4 text-xl md:text-2xl font-semibold text-foreground-900">
          页面未找到
        </h2>
        <p className="mt-2 text-sm text-foreground-500 max-w-md mx-auto leading-relaxed">
          你访问的页面可能已被移除、链接失效，或者你输入了错误的地址。
        </p>
        <div className="mt-8 flex items-center justify-center gap-4">
          <Link
            to="/"
            className="px-6 py-3 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-100 text-foreground-700 rounded-md text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap"
          >
            联系我们
          </Link>
        </div>
      </div>
    </div>
  );
}